module.exports = __webpack_public_path__ + "static/fonts/Oxanium-ExtraBold.26de805d.ttf";